export const BASE_URL = 'https://account-api.patna.ng/api/v1';
export const BASE_URL1 = 'https://asset-api.patna.ng/api';
// export const TOKEN = 'hINpsFmjuIyiAWSTGUl5GdhqbeHGyZGNEzcyshUh';
// export const TOKEN = 'JewOpsbGT6dWk6Kq0ycCUFz02kbPVL9eGYybrsfU';
export const TOKEN = 'ZNz11Q9H3JBg5REoPr1sUyqfuk7wnAtZAZXrLCsT';
// export const TOKEN = 'hINpsFmjuIyiAWSTGUl5GdhqbeHGyZGNEzcyshUh';